import * as TableSort from 'tablesort';
const SubContractorsTableSort = () => {
	const tableEl = document.getElementById('subContractorsTable');

	if (!tableEl) return;

	new TableSort(tableEl);

}

export default SubContractorsTableSort;